import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_INPUT_GENERICO } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
// import { crearCategoria, modificarCategoria } from "../../../api/api-categoria";
// import cargandoCard from "../../../components/cargando-card";
// import { obtenerListaCategoria } from "../../../api/api-categoria";
// import Select from "react-select";
// import { actualizarProducto, crearProducto } from "../../../api/api-producto";
import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../../components/processing-dialog";
import ToastComponent from "../../../components/toast-component";
import { actualizarProgressBar, crearProgressBar } from "../../../api/api-progress-bar";

export default function ProgressBarPage() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [titulo, setTitulo] = useState("");
  // const [listaCategoria, setListaCategoria] = useState([]);
  // const [categoriaSelected, setCategoriaSelected] = useState(null);

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning");

  useEffect(() => {
    // console.log("entro a Correos");
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data !== undefined && data !== null) {
        setFormData(data.params);
        setTitulo(data.titulo);
      }
      // const categorias = await obtenerListaCategoria({ habilitado: 1 }, true);
      // setListaCategoria(categorias);
      // if (data.params.idCategoria !== undefined && data.params.idCategoria !== null) {
      //   const categoria = categorias.find((item) => item.value === data.params.idCategoria);
      //   setCategoriaSelected(categoria);
      // }
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const charLimits = {
    inicio: 3,
    fin: 3,
    color: 7,
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // inicio and fin: only digits 0-9, value between 0 and 100
    if (name === "inicio" || name === "fin") {
      const digitsOnly = value.replace(/[^0-9]/g, "");
      if (digitsOnly === "") {
        setFormData({ ...formData, [name]: "" });
        return;
      }
      const num = parseInt(digitsOnly, 100);
      if (num > 101) return;
      setFormData({ ...formData, [name]: digitsOnly });
      return;
    }
    if (value.length <= charLimits[name]) {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validarFormulario = () => {
    try {
      let message = "";
      if (String(formData.inicio).trim().length === 0) {
        message = message + t("alert_debe_ingresar_inicio") + '\n';
      }
      if (String(formData.fin).trim().length === 0) {
        message = message + t("alert_debe_ingresar_fin") + '\n';
      }
      if (String(formData.color).trim().length === 0) {
        message = message + t("alert_debe_ingresar_color") + '\n';
      }
      if (message.length > 0) {
        alert(message);
        return false;
      }
      return true;
    } catch (err) {
      console.log('validarFormulario err');
      console.log(err);
      return false;
    }
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const handleSaveClick = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('formData');
    // console.log(formData);
    const valido = validarFormulario();
    if (valido === false) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = formData.id;
    objEnviar.inicio = formData.inicio;
    objEnviar.fin = formData.fin;
    objEnviar.color = formData.color;
    setProcessingVisible(true);
    if (formData.id === 0) {
      // console.log('crear correo');
      const response = await crearProgressBar(objEnviar);
      setProcessingVisible(false);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        showToast(t("alert_se_creo_correctamente"));
        handleCancelClick();
      }
      if (response.error === true) {
        showToast(t("alert_no_se_pudo_crear"));
      }
    }
    if (formData.id !== 0) {
      // console.log('actualizar correo');
      const response = await actualizarProgressBar(objEnviar);
      setProcessingVisible(false);
      // console.log('modificado');
      // console.log(modificado);
      if (response.error === false) {
        showToast(t("alert_se_modifico_correctamente"));
        handleCancelClick();
      }
      if (response.error === true) {
        showToast(t("alert_no_se_pudo_modificar"));
      }
    }
  };

  const handleColorChange = (e) => {
    let { value } = e.target;

    // Allow empty string
    if (value === '') {
      setFormData({
        ...formData,
        color: value,
      });
      return;
    }

    // If it doesn't start with #, add it automatically
    if (!value.startsWith('#')) {
      value = '#' + value;
    }

    // Allow "#" followed by 0-6 hex characters (allows partial input while typing)
    const hexPart = value.substring(1);
    if (/^[A-Fa-f0-9]{0,6}$/.test(hexPart) && value.length <= 7) {
      setFormData({
        ...formData,
        color: value.toUpperCase(),
      });
    }
  };

  const handleColorPickerChange = (e) => {
    const { value } = e.target;
    // Color picker always returns valid hex format
    setFormData({
      ...formData,
      color: value.toUpperCase(),
    });
  };

  const render = () => {
    // console.log('render correo');
    try {
      // if (cargandoPage === true) {
      //   return cargandoCard();
      // }
      // if (cargandoPage === false && formData === null) {
      //   return (
      //     <div>
      //       <label> Sin data</label>
      //     </div>
      //   );
      // }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6 bg-gray-100">
          <br />
          <div className="bg-white py-6 shadow-md rounded-lg sm:px-2">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <ArrowBack onClick={handleCancelClick} />
                  <h2 className="text-xl font-bold text-gray-900">{titulo}</h2>
                </div>
              </div>
            </div>
            {/* <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="categoria">
                  {t("label_categoria")}
                </label>
                <Select options={listaCategoria}
                  isSearchable='true'
                  isClearable='true'
                  value={categoriaSelected}
                  onChange={(event) => setCategoriaSelected(event)}
                  placeholder={t("placeholder_seleccione_categoria")}
                />
              </div>
            </div>
            <br /> */}
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="inicio"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_start")}<span className="text-red-500">*</span>
                </label>
                <input
                  id="inicio"
                  name="inicio"
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={formData.inicio}
                  onChange={handleInputChange}
                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.inicio}
                  placeholder={t("placeholder_ingresa_inicio")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.inicio.length}/{charLimits.inicio}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="fin"
                  className="block text-md font-medium text-gray-700"
                >
                  {t("label_end")}<span className="text-red-500">*</span>
                </label>
                <input
                  id="fin"
                  name="fin"
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  value={formData.fin}
                  onChange={handleInputChange}
                  className={ESTILO_INPUT_GENERICO}
                  required
                  maxLength={charLimits.fin}
                  placeholder={t("placeholder_ingresa_fin")}
                />
                <p className="text-sm text-gray-500 flex justify-end">{formData.fin.length}/{charLimits.fin}</p>
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  htmlFor="color"
                  className="block text-md font-medium text-gray-700 "
                >
                  {t("label_color")}<span className="text-red-500">*</span>
                </label>
                <div className="flex gap-2 items-center">
                  <input
                    id="color"
                    name="color"
                    type="text"
                    value={formData.color || '#000000'}
                    onChange={handleColorChange}
                    className={ESTILO_INPUT_GENERICO}
                    placeholder="#FF00FF"
                    maxLength={7}
                  />
                  <input
                    type="color"
                    value={formData.color || '#000000'}
                    onChange={handleColorPickerChange}
                    className="h-10 w-16 cursor-pointer border border-gray-300 rounded"
                    title={t("label_seleccionar_color")}
                  />
                </div>
                <p className="text-sm text-gray-500 flex justify-end">{formData?.color?.length}/{charLimits.color}</p>
                {formData.color && !/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(formData.color) && (
                  <p className="text-sm text-red-500 mt-1">
                    {t("alert_formato_color_invalido")}
                  </p>
                )}
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between">
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_CANCELAR}
                    onClick={handleCancelClick}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_ACEPTAR}
                    onClick={handleSaveClick}
                  >
                    Aceptar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('formData render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
